import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Home: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_848_4)">
        <path
          d="M23.8626 10.1341C23.674 10.4628 23.3282 10.6466 22.9735 10.6466C22.7993 10.6466 22.623 10.6022 22.4617 10.5086L12.0003 4.46875L1.53762 10.5086C1.04831 10.7915 0.420273 10.6247 0.137349 10.1334C-0.145575 9.64339 0.021856 9.01604 0.512531 8.73311L11.4878 2.3974C11.8056 2.21356 12.1944 2.21356 12.5129 2.3974L23.4874 8.73311C23.9774 9.01672 24.1455 9.64407 23.8626 10.1341ZM21.2664 11.1995V20.715C21.2664 21.2808 20.8072 21.7401 20.2413 21.7401H16.1007C15.5348 21.7401 15.0756 21.2808 15.0756 20.715V17.6958C15.0756 16.001 13.6951 14.6205 12.0003 14.6205C10.3055 14.6205 8.92507 16.001 8.92507 17.6958V20.715C8.92507 21.2808 8.46515 21.7401 7.89998 21.7401H3.75864C3.19279 21.7401 2.73355 21.2808 2.73355 20.715V11.1995C2.73355 10.8332 2.929 10.4949 3.24609 10.3117L11.4878 5.55466C11.8056 5.37151 12.1944 5.37151 12.5129 5.55466L20.7539 10.3117C21.0703 10.4942 21.2664 10.8332 21.2664 11.1995ZM19.2163 11.7913L12.0003 7.62602L4.78372 11.7913V19.6906H6.8749V17.6965C6.8749 14.8693 9.17382 12.571 12.0003 12.571C14.8268 12.571 17.1258 14.8693 17.1258 17.6965V19.6906H19.2163V11.7913Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_848_4">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Home;
